import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["radioInput"];
  timeout = null; // used for debounce
  isSaving = false; // prevent multiple simultaneous saves

  connect() {
    this.blockId = this.element.dataset.blockId;
    this.blockType = 'radio';
    this.applyBoldToSelected();
  }

  select(event) {
    this.selectedRadio = event.target;
    this.applyBoldToSelected();
    this.save(event);
  }

  save(event) {
    // Mark this block as actively being edited
    window.activeEditingManager.startEditing(this.blockId, this.blockType, this.element);
    
    // Clear any previous scheduled save
    clearTimeout(this.timeout);

    // Set a new timeout to delay the save
    this.timeout = setTimeout(() => {
      this.performSave();
    }, 2000); // 500ms debounce delay
  }

  performSave() {
    if (!this.selectedRadio) return; // Prevent saving if no selection is made

    // Prevent multiple simultaneous saves
    if (this.isSaving) {
      console.log("Save already in progress, skipping...");
      return;
    }

    this.isSaving = true;

    const selectedValue = this.selectedRadio.value;
    const { accountId, projectId, taskListId, taskId, blockId } = this.element.dataset;

    fetch(`/${accountId}/projects/${projectId}/task_lists/${taskListId}/tasks/${taskId}/task_blocks/${blockId}/update_content`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
      },
      body: JSON.stringify({ 
        task_block: { value: selectedValue },
        skip_broadcast: false // Always broadcast - the channel will skip updates for the editing user
      })
    })
    .then(response => response.json())
    .then(data => {
      if (data.success) {
        console.log("Radio button selection saved:", data.value);
        // Stop editing after successful save
        window.activeEditingManager.stopEditing(this.blockId, 500);
      } else {
        console.error("Failed to save radio button selection:", data);
        // Stop editing even on error
        window.activeEditingManager.stopEditing(this.blockId, 1000);
      }
    })
    .catch(error => {
      console.error("Error saving radio button selection:", error);
      // Stop editing on error
      window.activeEditingManager.stopEditing(this.blockId, 1000);
    })
    .finally(() => {
      this.isSaving = false;
    });
  }

  applyBoldToSelected() {
    // Remove bold from all radio labels
    this.element.querySelectorAll(".radio-button").forEach(label => {
      label.classList.remove("checked");
    });

    // Find the selected radio button and add bold styling
    const selectedRadio = this.element.querySelector("input[type='radio']:checked");
    if (selectedRadio) {
      selectedRadio.closest(".radio-button").classList.add("checked");
    }
  }

  disconnect() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    // Clean up editing state when controller disconnects
    if (this.blockId) {
      window.activeEditingManager.stopEditing(this.blockId, 0); // No debounce on disconnect
    }
  }
}
